import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propChildren, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import SlideSearchHeaderSideMenuProfile from '../../Common/SlideSearchHeaderSideMenuProfile';
const SlideSearchHeaderSideMenuSpProfile = (props) => {
    const { className, planComponent, profile } = props;
    return (_jsxs("div", Object.assign({ className: clsx('slide_search_header_side_menu_sp_profile', className) }, { children: [_jsx(SlideSearchHeaderSideMenuProfile, { className: 'profile_main', profile: profile }), _jsx("div", Object.assign({ className: 'profile_plan' }, { children: planComponent }))] })));
};
SlideSearchHeaderSideMenuSpProfile.propTypes = {
    className: propStr(),
    planComponent: propChildren(),
    profile: propShape().isRequired,
};
SlideSearchHeaderSideMenuSpProfile.defaultProps = {
    className: '',
    planComponent: undefined,
};
export default SlideSearchHeaderSideMenuSpProfile;
